import { Injectable } from "@angular/core";
import { parseList } from "@helpers/functions";
import { SocketService } from "../socket.service";
import { CryptoTransactionNotifyService } from "../notify/crypto_transaction.notify.service";
import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";
import { DerivativeWalletService } from "./derivative_wallet.service";
import { ETC_TRANSACTIONS_ROOM, ETC_WALLETS_ROOM } from "@helpers/constants";
import { DerivativeTransaction } from "@models/transaction";
import { GetPendingTradesGQLService } from "@gql/offer";
import { ApicallService } from "@core-services/apicall.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { Etc } from "@models/derivative/currencies/etc";
import { EtcWallet } from "@models/derivative/wallets/etc_wallet";
import { EtcService } from "@main-services/currency/etc.service";

const name = ServiceNames.ETC_WALLET;

@Injectable({
	providedIn: "root"
})
export class EtcWalletService extends DerivativeWalletService<EtcWallet, Etc> {
	public name: string = ServiceNames.ETC_WALLET;

	public TxType = DerivativeTransaction;
	public WalletType = EtcWallet;

	protected transactionSocketRoomName: string = ETC_TRANSACTIONS_ROOM;
	protected walletSocketRoomName: string = ETC_WALLETS_ROOM;

	public constructor(
		protected currencyService: EtcService,
		protected apicallService: ApicallService,
		protected infoService: InfoService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected initService: InitService,
		protected transactionNotifyService: CryptoTransactionNotifyService,
		protected destructor: DestructorService,
		protected getPendingTradesGQLService: GetPendingTradesGQLService
	) {
		super(initService, destructor, name, getPendingTradesGQLService);
	}

	public getCanCreateMore(): boolean {
		return this.canCreateMore;
	}

	public getCannotCreateReason(): string {
		return this.cannotCreateReason;
	}

	public getParseData(wallets): EtcWallet[] {
		if (!wallets || !wallets["attributes"]["security"]["etc"]) {
			return [];
		}
		return parseList(wallets["attributes"]["security"]["etc"]["attributes"]["wallets"], EtcWallet);
	}
}
